import { createContext } from 'react';

import AtsValidationError, { ValidationError, ValidationErrorMap } from '@models/ValidationError';

export type ValidationValues = {
  clearValidationErrors: VoidFunction;
  getFieldError: (fieldName: string) => string | undefined;
  getGeneralErrors: () => AtsValidationError[] | undefined;
  setValidationErrors: (validationError: ValidationError) => void;
  validationErrorMap: ValidationErrorMap;
};

const ValidationContext = createContext<ValidationValues>({
  clearValidationErrors: () => void 0,
  getFieldError: () => void 0,
  getGeneralErrors: () => void 0,
  setValidationErrors: () => void 0,
  validationErrorMap: {} as ValidationErrorMap,
});

export default ValidationContext;
